import api from './api';

// ── Auth ──────────────────────────────────────────────────────────────────
export const sendOtp        = (phone)       => api.post('/auth/patient/send-otp', { phone });
export const verifyOtp      = (phone, otp)  => api.post('/auth/patient/verify-otp', { phone, otp });
export const completeProfile = (data)       => api.put('/auth/patient/profile', data);
export const updateLocation = (city, area)  => api.put('/auth/patient/location', { city, area });
export const getMyProfile   = ()            => api.get('/auth/patient/me');

// ── Doctors ───────────────────────────────────────────────────────────────
export const searchDoctors        = (params) => api.get('/doctors/search',      { params });
export const getSearchSuggestions = (q)      => api.get('/doctors/suggestions', { params: { q } });
export const getDoctorProfile = (id)       => api.get(`/doctors/${id}/profile`);
export const getDoctorSlots   = (id, date, type) =>
  api.get(`/slots/doctor/${id}`, { params: { date, type } });

// ── Reviews ───────────────────────────────────────────────────────────────
export const getDoctorReviews = (doctorId, params) =>
  api.get(`/reviews/doctor/${doctorId}`, { params });
export const createReview     = (data) => api.post('/reviews', data);
export const getLatestReviews = (limit = 10) => api.get('/reviews/latest', { params: { limit } });

// ── Appointments ──────────────────────────────────────────────────────────
export const getOrderSummary  = (data)  => api.post('/appointments/order-summary', data);
export const createOrder      = (data)  => api.post('/appointments/create-order', data);
export const verifyAndBook    = (data)  => api.post('/appointments/verify-and-book', data);
export const recoverBooking   = (orderId) => api.post('/appointments/recover-booking', { orderId });
export const checkReturningPatient = (doctorId) => api.get('/appointments/check-returning', { params: { doctorId } });
export const getMyAppointments       = (params) => api.get('/appointments/mine', { params });
export const getMyAppointmentDetail = (id)     => api.get(`/appointments/mine/${id}`);
export const getAppointment   = (id)    => api.get(`/appointments/${id}`);
export const getCancelInfo    = (id)    => api.get(`/appointments/${id}/cancel-info`);
export const cancelAppointment = (id)   => api.post(`/appointments/${id}/cancel`);

// ── Chat ──────────────────────────────────────────────────────────────────
export const getConversations  = ()                => api.get('/chat/conversations');
export const getChatHistory    = (convId, params)  => api.get(`/chat/${convId}`, { params });
export const sendMessage       = (data)            => api.post('/chat/message', data);
export const uploadChatFile    = (formData)        => api.post('/chat/upload', formData, {
  headers: { 'Content-Type': 'multipart/form-data' },
});
export const getSlotById          = (slotId)        => api.get(`/slots/${slotId}`);
export const getSlotStatus        = (appointmentId) => api.get(`/chat/slot-status/${appointmentId}`);
export const deleteChatMessage  = (messageId) => api.delete(`/chat/message/${messageId}`);
export const deleteConversation = (conversationId, deleteFor = 'me') =>
  api.delete(`/chat/conversation/${conversationId}?deleteFor=${deleteFor}`);

// ── Notifications ─────────────────────────────────────────────────────────
export const getNotifications  = (params) => api.get('/notifications', { params });
export const markAllRead       = ()       => api.put('/notifications/read-all');
export const markNotifRead        = (id) => api.put(`/notifications/${id}/read`);
export const deleteNotification   = (id) => api.delete(`/notifications/${id}`);
export const deleteAllNotifications = ()  => api.delete('/notifications');

// ── App (webapp) Reviews ──────────────────────────────────────────────────
export const submitAppReview  = (data)          => api.post('/app-reviews', data);
export const getAppReviews    = (limit = 20)    => api.get('/app-reviews', { params: { limit } });
